// extracted by mini-css-extract-plugin
export default {"container":"userAccountEdit_container__1YFtc","col":"userAccountEdit_col__Jo9m6","backlink":"userAccountEdit_backlink__vC-yE","btn-wrap":"userAccountEdit_btn-wrap__9ck0D"};